/**
 * Compute a fluid value across breakpoints.
 *
 * @param {object} opts
 *   minSize: number (unitless theme value)
 *   maxSize: number (unitless theme value)
 *   minVW: number (px)
 *   maxVW: number (px)
 *   baseFontMin: number (px) font base at minVW
 *   baseFontMax: number (px) font base at maxVW
 *   precision: number
 */
export const fluid = (opts) => {
  const {
    minSize,
    maxSize,
    minVW,
    maxVW,
    baseFontMin,
    baseFontMax,
    precision = 4,
  } = opts;

  if (
    [minSize, maxSize, minVW, maxVW, baseFontMin, baseFontMax].some(
      (v) => typeof v !== "number"
    )
  ) {
    throw new Error("fluid(): all options must be numbers");
  }
  if (maxVW <= minVW) throw new Error("fluid(): maxVW must be > minVW");

  // Convert unitless theme values to px using corresponding baseFont
  const minPx = minSize * baseFontMin;
  const maxPx = maxSize * baseFontMax;

  // Slope in px per px
  const slope = (maxPx - minPx) / (maxVW - minVW);
  const intercept = minPx - slope * minVW;

  // Convert slope to vw unit
  const slopeVW = slope * 100;

  // Convert intercept to rem based on min baseFont
  const interceptRem = intercept / baseFontMin;

  const f = (n) => Number(n).toFixed(precision);

  return `clamp(${f(minPx / baseFontMin)}rem, ${f(slopeVW)}vw + ${f(
    interceptRem
  )}rem, ${f(maxPx / baseFontMax)}rem)`;
};
